import { Link } from '@tanstack/react-router';

export function EmailInUseError() {
    return (
        <>
            This address is already being used with a Nesso account.{' '}
            <Link to="/login" className="underline underline-offset-4">
                Log in
            </Link>{' '}
            instead
        </>
    );
}
